// PWA service-worker registration for PromptKiste AI (Norrbyte).
// Safe to call multiple times — registration is idempotent.

export function registerServiceWorker() {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;
  // Don't register in development unless explicitly enabled (CRA dev SW caches
  // are usually noise — but we DO want it in production builds).
  const isLocalhost =
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1";

  // Register on window load to not compete with first paint.
  window.addEventListener("load", () => {
    const swUrl = "/service-worker.js";

    navigator.serviceWorker
      .register(swUrl, { scope: "/" })
      .then((registration) => {
        // Auto-update: when a new SW is found, ping the user once it's ready.
        if (registration && registration.update) {
          // Trigger an update check on next focus
          window.addEventListener("focus", () => registration.update().catch(() => {}));
        }

        if (isLocalhost) {
          // eslint-disable-next-line no-console
          console.log("[PWA] Service worker registered (localhost)");
        }
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.warn("[PWA] Service worker registration failed:", err);
      });
  });
}
